export enum MimeType {
    JPG = 'image/jpeg',
    GLB = 'application/octet-stream',
    CSV = 'text/csv',
    GLTF = 'application/json',
    JSON = 'application/json',
    not_specified = 'application/octet-stream'
}
